import { render } from "./unionOrderDishModel.vue?vue&type=template&id=ffe2dc10"
import script from "./unionOrderDishModel.vue?vue&type=script&lang=js"
export * from "./unionOrderDishModel.vue?vue&type=script&lang=js"

import "./unionOrderDishModel.vue?vue&type=style&index=0&id=ffe2dc10&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__